import { Checkbox, FormControlLabel } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly label: string;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly onChange: (checked: boolean) => void;
}

const LabelledCheckbox: FC<Props> = ({ label, checked, disabled, onChange }) => (
  <FormControlLabel
    control={<Checkbox checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />}
    label={label}
  />
);

export default LabelledCheckbox;
